<template>
  <div :class="{
    'dayplan-preview': true,
    'is-selectable': !showTime,
    'is-invalid': checkValidity
  }">
    <h3>Plan {{planId}}</h3>
    <div
      v-for="(item, idx) in plan"
      :key="item.label"
      :class="{
        'dayplan-preview__item': true,
        'dayplan-preview--selected': selected
      }"
      :style="{
        minHeight:  '23px',
        height:     calcItemHeight(item) + 'px',
        lineHeight: calcItemHeight(item) + 'px'
      }"
      @click="onClick">
      {{item.label}}
      <span v-if="showTime" class="dayplan-preview__time">
        <!-- {{item.from * 3600|formatSeconds}} -->
        <!-- <time-selector-inline-new v-model="item.from" /> -->
        <time-selector-inline :value="numToTime(item.from)" @save="onUpdate( idx, $event )" />
      </span>
    </div>
    <div v-if="checkValidity" class="text-center">Invalid input</div>
    <!-- <pre>{{plan}}</pre> -->
  </div>
</template>

<script>
import moment from '@/moment-gp'

export default {
  props: {
    planId:   { type: Number },
    plan:     { type: Array }, // This will be mutated
    selected: { type: Boolean },
    showTime: { type: Boolean },
  },
  computed: {
    checkValidity() {
      let t = 0
      let invalid = false;
      this.plan.forEach(item => {
        if ( item.from < t || item.to <= item.from ) {
          invalid = true;
          return
        }
        t = item.to;
      })
      return invalid;
    },
  },
  methods: {
    onUpdate(idx, value) {
      let time = moment.convertHHmmToFractional(value)
      this.plan[ idx ].from = time;
      if ( idx === this.plan.length - 1 ) {
        if ( time <  6 ) {
           // HACK
          time = time + 24;
          this.plan[ idx ].from = time;
        }
        this.plan[ idx ].to = time + 1;
      }
      if ( idx > 0 ) {
        this.plan[ idx - 1 ].to = time;
      }
    },
    calcItemHeight(item) {
      return ( ( item.to - item.from ) * 30 );
    },
    onClick() {
      this.$emit('select', this.planId )
    },
    numToTime(value) {
      // return moment([2000, 1, 1, value, 0, 0, 0]).format('HH:mm')
      return moment.convertFractionalToHHmm(value);
    },
  },
}
</script>

<style>
.dayplan-preview {
  width: 200px;
}
.dayplan-preview.is-selectable:hover {
  cursor: pointer;
}
.dayplan-preview.is-selectable:hover .dayplan-preview__item {
  border-color: #409EFF;
  color: #409EFF;
}
.dayplan-preview.is-invalid .dayplan-preview__item {
  border-color: red;
  color: red;
}
.dayplan-preview .dayplan-preview__item.dayplan-preview--selected {
  border-color: #409EFF;
  border-width: 3px;
  color: #409EFF;
}
.dayplan-preview .dayplan-preview__item {
  border: 2px solid gray;
  width: 100%;
  vertical-align: middle;
  line-height: 30px;
  text-align: center;
  font-size: 1.3em;
  margin-bottom: 5px;
  position: relative;
}
.dayplan-preview__time {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  line-height: 1;
  border-top: 2px solid gray;
  transform: translateX(110%);
  padding-left: 30px;
  margin-top: -2px;
}
</style>
